import { create } from 'zustand';
import { PaymentStatementMemo, PaymentStatementPurchase, PaymentStatementRefund } from '@models/paymentStatement';
import { SalesChannelsType } from '@models/sales-channels';

type RefundStep = 'INFO' | 'ACCEPTED' | 'DENIED' | 'PARTNER_REQUEST';
export interface RefundModalData {
  channel?: SalesChannelsType;
  orderId: string;
  uid?: string;
  productName: string;
  reason?: string;
  refundInfo?: PaymentStatementRefund;
  historyRefundItems?: PaymentStatementPurchase[];
  requestAt?: Date;
  purchases?: PaymentStatementPurchase[];
  remainPurchases?: PaymentStatementPurchase[];
  remainAmount?: number;
  type?: 'partner_request';
  memo?: PaymentStatementMemo;
  naverProductOrderStatus?: string;
}
interface State {
  data?: RefundModalData;
  step: RefundStep;
  show: boolean;
}
interface Actions {
  open: (data: RefundModalData) => void;
  close: () => void;
  changeStep: (step: RefundStep) => void;
}

const useRefundModalStore = create<State & Actions>((set) => ({
  show: false,
  step: 'INFO',
  data: undefined,
  close: () => set({ show: false, data: undefined, step: 'INFO' }),
  open: (data) => set({ data, show: true }),
  changeStep: (step) => set({ step }),
}));

export default useRefundModalStore;
